<template>
  <div>
    <div v-if="isLoading" class="loading-overlay">
      <div class="spinner-border text-light" role="status"></div>
      <p>Cargando...</p>
    </div>
    <h5 class="fw-bold fs-4 mb-3">
      Registro de envío {{ tipoEnvio }} - Documentos
    </h5>
    <form @submit.prevent="submitForm">
      <div class="row">
        <div class="col-lg-6">
          <div class="card bg-card mt-4">
            <div class="card-header"><i class="bi bi-building"></i> Información del Remitente</div>
            <div class="card-body">
              <div class="row">
                <div class="form-group row">
                  <div class="col-md-9">
                    <label class="required" for="ruc_remitente">
                      RUC Remitente
                    </label>
                    <input v-model="form.ruc_remitente" :class="{ 'is-invalid': errors.ruc_remitente }"
                      id="ruc_remitente" @input="errors.ruc_remitente = false" class="form-control" />
                  </div>
                  <div class="col-md-3">
                    <br />
                    <a role="button" class="btn btn-primary text-white btn-sm align-items-center gap-2"
                      @click="getEmpresaRemitente()">
                      <i class="bi bi-search"></i>
                      Buscar
                    </a>
                  </div>
                </div>

                <div class="form-group row">
                  <div class="col-lg-9">
                    <label class="required" for="remitente">Remitente (Cliente Inicial)</label>
                    <select v-model="form.remitente" :class="{ 'is-invalid': errors.remitente }" disabled id="remitente"
                      @change="getSucursalesRemitente()" class="form-control">
                      <option v-for="item in empresas" :key="item.id" :value="item.id">
                        {{ item.nombre }}
                      </option>
                    </select>
                  </div>
                  <div class="col-lg-3">
                    <br />
                    <a role="button" v-if="form.remitente" class="btn btn-primary btn-sm mx-1 text-white"
                      @click="openModalDirecciones(form.remitente, sucursalesRemitente, 'remitente')">
                      <i class="bi bi-gear me-1"></i> Gestionar
                    </a>

                  </div>

                </div>

                <div class="form-group">
                  <label class="required" for="sucursal_remitente_id">
                    Seleccione Dirección del Remitente (Cliente Final)
                  </label>
                  <SelectDireccion v-model="form.sucursal_remitente_id" :options="sucursalesRemitente"
                    id="sucursal_remitente_id" :class="{ 'is-invalid': errors.sucursal_remitente_id }"
                    placeholder="Seleccione Dirección del Remitente (Cliente Final)"
                    @change="buscarDireccionRemitente()" />

                  <label class="mt-2" for="id_contacto_sucursal_origen">
                    Contacto del Remitente
                  </label>
                  <input readonly :value="sucursalRemitente && sucursalRemitente.nombre_contacto"
                    id="sucursal_remitente_id" type="text" class="form-control" />
                  <label for="id_contacto_sucursal_origen">
                    Telefono de Contacto
                  </label>
                  <input readonly :value="sucursalRemitente && sucursalRemitente.telefono_contacto"
                    id="sucursal_remitente_id" type="text" class="form-control" />
                  <label for="id_contacto_sucursal_origen">
                    Area de Atención
                  </label>
                  <input readonly :value="sucursalRemitente && sucursalRemitente.cargo_contacto" id="id_cargo_contacto"
                    type="text" class="form-control" />

                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="card bg-card mt-4">
            <div class="card-header"><i class="bi bi-geo-alt"></i> Información del Destinatario</div>
            <div class="card-body">
              <div class="row">
                <div class="form-group row">
                  <div class="col-md-9">
                    <label class="required" for="ruc_destinatario">
                      RUC Destinatario
                    </label>
                    <input v-model="form.ruc_destinatario" :class="{ 'is-invalid': errors.ruc_destinatario }"
                      id="ruc_destinatario" class="form-control" @input="errors.ruc_destinatario = false" />


                  </div>
                  <div class="col-md-3">
                    <br />
                    <a role="button" class="btn btn-primary text-white btn-sm align-items-center gap-2"
                      @click="getEmpresaDestinatario()">
                      <i class="bi bi-search"></i>
                      Buscar
                    </a>
                  </div>
                </div>
                <div class="form-group row">


                  <div class="col-lg-9">
                    <label class="required" for="destinatario">
                      Destinatario (Cliente Inicial)
                    </label>
                    <select disabled v-model="form.destinatario" :class="{ 'is-invalid': errors.destinatario }"
                      id="destinatario" @change="getSucursalesDestinatario()" class="form-control">
                      <option v-for="item in empresas" :key="item.id" :value="item.id">
                        {{ item.nombre }}
                      </option>
                    </select>
                  </div>
                  <div class="col-lg-3">
                    <br />
                    <a role="button" v-if="form.destinatario" class="btn btn-primary btn-sm mx-1 text-white"
                      @click="openModalDirecciones(form.destinatario, sucursalesDestinatario, 'destinatario')">
                      <i class="bi bi-gear me-1"></i> Gestionar
                    </a>

                  </div>
                </div>



                <div class="form-group">
                  <label class="required" for="id_direccion_sucursal_destino">
                    Seleccione Dirección del Destinatario (Cliente Final)
                  </label>
                  <SelectDireccion v-model="form.sucursal_destinatario_id" :options="sucursalesDestinatario"
                    id="id_direccion_sucursal_destino" :class="{ 'is-invalid': errors.sucursal_destinatario_id }"
                    placeholder="Seleccione Dirección del Destinatario (Cliente Final)"
                    @change="buscarDireccionDestinatario()" />
                  <label class="mt-2" for="id_contacto_sucursal_origen">
                    Contacto del Destinatario
                  </label>
                  <input readonly :value="sucursalDestinatario && sucursalDestinatario.nombre_contacto"
                    id="id_direccion_sucursal_origen" type="text" class="form-control" />
                  <label for="id_contacto_sucursal_origen">
                    Telefono de Contacto
                  </label>
                  <input readonly :value="sucursalDestinatario && sucursalDestinatario.telefono_contacto"
                    id="id_direccion_sucursal_origen" type="text" class="form-control" />
                  <label for="id_contacto_sucursal_origen">
                    Area de Atención
                  </label>
                  <input readonly :value="sucursalDestinatario && sucursalDestinatario.cargo_contacto"
                    id="id_cargo_contacto" type="text" class="form-control" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card bg-card mt-4">
        <div class="card-header"><i class="bi bi-send"></i> Información del Envío</div>
        <div class="card-body">

          <div class="row">
            <div class="form-group col-lg-3">
              <label class="required" for="cod_metodo_envio_id">
                Area solicitante
              </label>
              <select @change="getDetalleMetodoEnvio()" class="form-control" v-model="form.cod_metodo_envio_id"
                id="cod_metodo_envio_id" :class="{ 'is-invalid': errors.cod_metodo_envio_id }">
                <option v-for="item in codigosMetodoEnvio" :key="item.id" :value="item.id">
                  {{ item.codigo }}
                </option>
              </select>
              <div v-if="errors.cod_metodo_envio_id" class="invalid-feedback">
                {{ errors.cod_metodo_envio_id }}
              </div>
            </div>




            <div class="form-group col-lg-2">
              <label class="required" for="fecha_salida">Fecha de Salida</label>
              <input type="date" class="form-control" :min="fechaSalidaMinimaAereo" v-model="form.fecha_salida"
                @change="getSolicitudesEnvio()" :class="{ 'is-invalid': errors.fecha_salida }"
                @input="errors.fecha_salida = false" />
              <div v-if="errors.fecha_salida" class="invalid-feedback">
                {{ errors.fecha_salida }}
              </div>
            </div>

            <div class="form-group col-lg-2">
              <label class="required" for="horario_salida">
                Horario de Salida
              </label>
              <input type="time" class="form-control" @change="changeHoraSalida()" v-model="form.horario_salida"
                id="horario_salida" :class="{ 'is-invalid': errors.horario_salida }"
                @input="errors.horario_salida = false" />
              <div v-if="errors.horario_salida" class="invalid-feedback">
                {{ errors.horario_salida }}
              </div>
            </div>
            <div class="form-group col-lg-3">
              <label class="required" for="id_tipo_envio">Tipo de Envío</label>
              <select class="form-control" v-model="form.id_tipo_envio" id="id_tipo_envio"
                :class="{ 'is-invalid': errors.id_tipo_envio }" @change="errors.id_tipo_envio = false">
                <option v-for="item in tiposEnvio" :key="item.id" :value="item.id">
                  {{ item.nombre }}
                </option>
              </select>
              <div v-if="errors.id_tipo_envio" class="invalid-feedback">
                {{ errors.id_tipo_envio }}
              </div>
            </div>
            <div class="form-group col-lg-2">
              <label class="required" for="id_solicitudes_envio">
                Solicitud de Envío
              </label>
              <select class="form-control" v-model="form.id_solicitudes_envio" id="id_solicitudes_envio"
                :class="{ 'is-invalid': errors.id_solicitudes_envio }" @change="errors.id_solicitudes_envio = false">
                <option v-for="item in solicitudesEnvio" :value="item.id_solicitudes_envio" :key="item.id">
                  {{ item.nombre }}
                </option>
              </select>
              <div v-if="errors.id_solicitudes_envio" class="invalid-feedback">
                {{ errors.id_solicitudes_envio }}
              </div>
            </div>

            <div class="form-group col-lg-2">
              <label class="required" for="fecha_entrada">
                Fecha de Entrega Programada
              </label>
              <input type="date" class="form-control" disabled v-model="form.fecha_entrada" id="fecha_entrada"
                :class="{ 'is-invalid': errors.fecha_entrada }" @input="errors.fecha_entrada = false" />
              <div v-if="errors.fecha_entrada" class="invalid-feedback">
                {{ errors.fecha_entrada }}
              </div>
            </div>

            <div class="form-group col-lg-2">
              <label class="required" for="fecha_entrada_maxima">
                Fecha de Entrega Máxima
              </label>
              <input type="date" class="form-control" @change="generarRangosHoras()" :disabled="!form.fecha_entrada"
                :min="form.fecha_entrada" v-model="form.fecha_entrada_maxima" id="fecha_entrada_maxima"
                :class="{ 'is-invalid': errors.fecha_entrada_maxima }" @input="generarRangosHoras()" />
              <div v-if="errors.fecha_entrada_maxima" class="invalid-feedback">
                {{ errors.fecha_entrada_maxima }}
              </div>
            </div>


            <div class="form-group col-lg-2">
              <label class="required" for="fecha_entrega">
                Horario de entrega máxima
              </label>
              <select class="form-control" v-model="form.horario_entrega" id="horario_entrega"
                :class="{ 'is-invalid': errors.horario_entrega }" @input="errors.horario_entrega = false">
                <option v-for="rango in rangosHoras" :key="rango" :value="rango">
                  {{ rango }}
                </option>
              </select>
              <div v-if="errors.horario_entrega" class="invalid-feedback">
                {{ errors.horario_entrega }}
              </div>
            </div>
            <div class="form-group col-lg-4">
              <label for="area_gestion">Area de gestión(En el cliente)</label>
              <input type="text" class="form-control" v-model="form.area_gestion"
                :class="{ 'is-invalid': errors.area_gestion }" @input="errors.area_gestion = false" />
              <div v-if="errors.area_gestion" class="invalid-feedback">
                {{ errors.area_gestion }}
              </div>
            </div>
            <div class="form-group col-lg-2">
              <label class="required" for="cant_bultos">Cant. Juegos</label>
              <input type="number" class="form-control" v-model="form.cant_bultos" id="cant_bultos" />
            </div>
            <div class="form-group col-lg-4">
              <label for="area_gestion">Solicitante</label>
              <input type="text" class="form-control" v-model="form.solicitante"
                :class="{ 'is-invalid': errors.solicitante }" @input="errors.solicitante = false" />
              <div v-if="errors.solicitante" class="invalid-feedback">
                {{ errors.solicitante }}
              </div>
            </div>
            <div class="form-group col-lg-2">
              <label for="area_gestion">Precio del servicio</label>
              <input type="text" disabled class="form-control" v-model="form.precio_servicio"
                :class="{ 'is-invalid': errors.precio_servicio }" @input="errors.precio_servicio = false" />
              <div v-if="errors.precio_servicio" class="invalid-feedback">
                {{ errors.precio_servicio }}
              </div>
            </div>
            <!-- <div class="form-group col-lg-2 ">
              <label for="retorno_cargos">Retorno de cargos(N° páginas)</label>
              <input type="text" disabled class="form-control" v-model="form.retorno_cargos"
                :class="{ 'is-invalid': errors.retorno_cargos }" @input="errors.retorno_cargos = false" />
              <div v-if="errors.retorno_cargos" class="invalid-feedback">
                {{ errors.retorno_cargos }}
              </div>
            </div> -->
            
            <div class="form-group col-lg-12">
              <label for="horas_extras">Observaciones</label>
              <textarea name="" v-model="form.observaciones" class="form-control no-resize" id="" cols="30"
                rows="5"></textarea>
            </div>
            <div class="form-group col-lg-12" v-if="isEmergency">
              <label for="horas_extras" class="required">Motivo de la Emergencia/Urgencia</label>
              <textarea required name="" v-model="form.observaciones_emergencia" class="form-control no-resize" id=""
                cols="30" rows="5"></textarea>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-12">
          <div class="card bg-card mt-4">
            <div class="card-header"><i class="bi bi-file-earmark-text"></i> Documentos del Envío</div>
            <div class="card-body">
              <!-- Formulario para agregar -->
              <div class="row">
                <div class="form-group col-lg-4">
                  <label class="required" for="detalle_metodo_envio_id">Detalle del Area Solicitante</label>
                  <select v-model="formDocumento.detalle_metodo_envio_id" class="form-control"
                    id="detalle_metodo_envio_id" :class="{ 'is-invalid': errors.detalle_metodo_envio_id }"
                    @change="errors.detalle_metodo_envio_id = false">
                    <option v-for="item in detallesMetodoEnvio" :key="item.id" :value="item.id">
                      {{ item.detalle }}
                    </option>
                  </select>
                  <div v-if="errors.detalle_metodo_envio_id" class="invalid-feedback">
                    {{ errors.detalle_metodo_envio_id }}
                  </div>
                </div>
                <div class="form-group col-lg-2">
                  <label for="orden_compra">N° Orden de compra</label>
                  <input type="text" v-model="formDocumento.orden_compra" id="orden_compra" class="form-control" />
                </div>
                <div class="form-group col-lg-2">
                  <label for="numero_factura">N° factura</label>
                  <input type="text" v-model="formDocumento.numero_factura" id="numero_factura" class="form-control" />
                </div>
                <div class="form-group col-lg-2">
                  <label for="otm">OTM</label>
                  <input type="text" v-model="formDocumento.otm" id="otm" class="form-control" />
                </div>
                <div class="form-group col-lg-10">
                  <label for="documentos_extras">Documentos extras</label>
                  <input type="text" v-model="formDocumento.documentos_extras" id="documentos_extras"
                    class="form-control" />
                </div>
                <div class="form-group col-md-1 d-flex align-items-end">
                  <a role="button" class="btn btn-sm btn-info d-flex align-items-center gap-2 text-white"
                    @click="agregarDocumento">
                    <i class="bi bi-plus-circle"></i>
                  </a>
                </div>
              </div>
              <!-- Tabla con listado -->
              <div class="row mt-4">
                <div class="col-lg-12">
                  <div class="card">
                    <div class="card-body">
                      <div class="table-responsive mt-2">
                        <table class="table table-font-small">
                          <thead class="table-light">
                            <tr>
                              <th>Detalle del Area Solicitante</th>
                              <th>N° Orden de compra</th>
                              <th>N° factura</th>
                              <th>OTM</th>
                              <th>Documentos extras</th>
                              <th>Acciones</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(doc, index) in form.documentos" :key="index">
                              <td>{{ getDetalleMetodoEnvioById(doc.detalle_metodo_envio_id) }}</td>
                              <td>{{ doc.orden_compra }}</td>
                              <td>{{ doc.numero_factura }}</td>
                              <td>{{ doc.otm }}</td>
                              <td>{{ doc.documentos_extras }}</td>
                              <td>
                                <a class="btn btn-sm btn-danger text-white" role="button"
                                  @click="eliminarDocumento(index)">
                                  <i class="bi bi-trash"></i>
                                </a>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div class="card bg-card mt-4">
        <div class="card-header"><i class="bi bi-truck"></i> Selección de Vehículo</div>
        <div class="card-body">
          <div class="row">
            <div class="form-group col-lg-6">
              <label class="required" for="origen_distrito">
                Tipo de unidad
              </label>
              <select v-model="form.tipo_unidad" id="tipo_unidad" @change="buscarUnidad()"
                class="form-control font-small">
                <option v-for="item in tipoUnidades" :key="item.id" :value="item.id">
                  {{ item.tipo_unidad }}
                </option>
              </select>
            </div>
            <div v-if="tipoEnvio == 'exclusivo'" class="form-group col-lg-21">
              <label class="required" for="cantidad_bultos">#Conductores</label>
              <select name="" id="" class="form-control" @change="buscarPrecio()" v-model="form.cant_conductor">
                <option value="1">1</option>
                <option value="2">2</option>
              </select>
            </div>

            <div v-if="tipoEnvio == 'exclusivo'" class="form-group col-lg-21">
              <label for="peso">Lead Time</label>
              <input type="text" v-model="form.lead_time_esperado" id="peso" disabled class="form-control" />
            </div>

            <div v-if="tipoEnvio == 'exclusivo'" class="form-group col-lg-21">
              <label for="peso">Precio</label>
              <input type="text" v-model="form.precio_servicio" id="peso" disabled class="form-control" />
            </div>
            <div class="form-group col-lg-12">
              <span @click="showdetalleUnidad = !showdetalleUnidad" class="text-primary hover-pointer">
                Ver Detalles de la unidad
              </span>
              <br />
              <div v-if="showdetalleUnidad" class="card mt-2">
                <div class="card-body">
                  <div class="table-responsive mt-4">
                    <table class="table table-font-small">
                      <thead class="table-light">
                        <tr>
                          <th>Capacidad de peso (TN)</th>
                          <th>Capacidad de carga ( M3)</th>
                          <th>Medidas del transporte</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{{ detalleUnidad.capacidad_peso }}</td>
                          <td>{{ detalleUnidad.capacidad_carga }}</td>
                          <td>{{ detalleUnidad.medidas_transporte }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mt-3 d-flex justify-content-end mb-3">
        <button type="submit" class="btn btn-primary d-flex align-items-center gap-2">
          <i class="bi bi-floppy"></i>
          Guardar
        </button>
      </div>
    </form>
    <div v-if="showModalDirecciones" class="modal fade show d-block" tabindex="-1"
      style="background: rgba(0, 0, 0, 0.5);">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Gestionar Direcciones</h5>
            <button type="button" class="btn-close" @click="showModalDirecciones = false"></button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="guardarDireccion">
              <div class="row">
                <div class="mb-3 col-lg-4">
                  <label class="form-label">Nombre</label>
                  <input type="text" class="form-control" v-model="direccionEdit.nombre" required />
                </div>
                <div class="mb-3 col-lg-8">
                  <label class="form-label">Dirección</label>
                  <input type="text" class="form-control" v-model="direccionEdit.direccion" required />
                </div>
                <div class="mb-3 col-lg-4">
                  <label class="form-label">Departamento</label>
                  <select class="form-control" @change="cargarProvincias" v-model="direccionEdit.departamento_id"
                    required>
                    <option v-for="item in departamentos" :value="item.id" :key="item.id">{{ item.nombre }}</option>
                  </select>
                </div>
                <div class="mb-3 col-lg-4">
                  <label class="form-label">Provincia</label>
                  <select @change="cargarDistritos" class="form-control" v-model="direccionEdit.provincia_id" required>
                    <option v-for="item in provincias" :value="item.id" :key="item.id">{{ item.nombre }}</option>
                  </select>
                </div>
                <div class="mb-3 col-lg-4">
                  <label class="form-label">Distrito</label>
                  <select class="form-control" v-model="direccionEdit.distrito_id" required>
                    <option v-for="item in distritos" :value="item.id" :key="item.id">{{ item.nombre }}</option>
                  </select>
                </div>
                <div class="mb-3 col-lg-4">
                  <label class="form-label">Nombre Contacto</label>
                  <input type="text" class="form-control" v-model="direccionEdit.nombre_contacto" />
                </div>
                <div class="mb-3 col-lg-3">
                  <label class="form-label">Área de atención</label>
                  <input type="text" class="form-control" v-model="direccionEdit.cargo_contacto" />
                </div>
                <div class="mb-3 col-lg-2">
                  <label class="form-label">Teléfono Contacto</label>
                  <input type="text" class="form-control" v-model="direccionEdit.telefono_contacto" />
                </div>
              </div>
              <div class="d-flex justify-content-end mb-3">
                <a @click="resetDireccion" class="btn btn-sm btn-danger text-white mx-2">
                  <i class="bi bi-x-circle me-1"></i> Cancelar
                </a>
                <button type="submit" class="btn btn-sm btn-primary">
                  <i class="bi bi-floppy me-1"></i> Guardar Dirección
                </button>
              </div>

            </form>
            <div class="table-responsive text-nowrap">
              <table class="table table-font-small mt-3">
                <thead class="table-light">
                  <tr>
                    <th>Nombre</th>
                    <th>Dirección</th>
                    <th>Departamento</th>
                    <th>Provincia</th>
                    <th>Distrito</th>
                    <th>Contacto</th>
                    <th>Área de atención</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="direccion in sucursalesData" :key="direccion.id">
                    <td>{{ direccion.nombre }}</td>
                    <td>{{ direccion.direccion }}</td>
                    <td>{{ direccion.departamento_nombre }}</td>
                    <td>{{ direccion.provincia_nombre }}</td>
                    <td>{{ direccion.distrito_nombre }}</td>
                    <td>{{ direccion.nombre_contacto }} {{ direccion.telefono_contacto }}</td>
                    <td>{{ direccion.cargo_contacto }}</td>
                    <td>
                      <button class="btn btn-warning btn-sm me-2" @click="editarDireccion(direccion)">
                        <i class="bi bi-pencil-square"></i>
                      </button>
                      <button class="btn btn-danger btn-sm" @click="eliminarDireccion(direccion.id)">
                        <i class="bi bi-trash3-fill"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Swal from 'sweetalert2'
import router from '@/router' // Asegúrate de importar tu instancia del router
import SelectDireccion from '@/components/SelectDireccion.vue'

export default {
  name: 'ShippingPage',
  components: { SelectDireccion },
  data() {
    return {
      isLoading: false,
      fechaSalidaMinimaAereo: '',
      isEmergency: false,
      envioId: this.$route.params.id,
      editandoDireccion: false,
      tipoEnvio: this.$route.params.tipo_envio,
      tipoEnvioLabel: '',
      rangosHoras: [],
      showModalDirecciones: false,
      errors: {},
      pedidoResponse: {},
      departamentos: [],
      provincias: [],
      distritos: [],
      formDocumento: {
        detalle_metodo_envio_id: '',
        guia_remitente: '',
        nro_pedido: '',
        orden_compra: '',
        numero_factura: '',
        otm: '',
        documentos_extras: '',
      },
      direccionEdit: {
        empresa_id: null,
        nombre: '',
        direccion: '',
        distrito_id: null,
        nombre_contacto: '',
        cargo_contacto: '',
        telefono_contacto: '',
        email_contacto: '',
      },
      sucursalRemitente: {},
      form: {
        sucursal_remitente_id: '',
        sucursal_destinatario_id: '',
        fecha_salida: null,
        fecha_entrada: '',
        dias_entrega: '',
        horas_extra: '',
        cod_metodo_envio_id: '',
        detalle_metodo_envio_id: '',
        documentos: [],
        documentos_extras: '',
        cant_bultos: '',
        cant_conductor: '1',
        precio_servicio: '',

        peso_bruto: '',
        peso_volumen: '',
        tipo_unidad: '1',
        medidas: '',
        flete: '',
        falso_flete_provincia: '',
        flete_cancelacion: '',
        flete_visita_extra: '',
        flete_hora_extra: '',
        flete_local_urgencia: '',
        gastos_admin: '',
        gastos_total: '',
        detalle_gastos_admin: '',
        id_causa_visita: '',
        detalle_causa_visita: '',
        detalle_mercaderia: '',
        id_modalidades_envio: '3',
        id_tipo_envio: '',
        id_solicitudes_envio: '',
        detalle_solicitud_envio: '',
        id_estados_envio: '1',
        id_causa_entrega: '',
        detalle_causa_entrega: '',
        lead_time_esperado: '',
        cumplimiento_lead_time: '',
        causa_cumplimiento_lead_time: '',
        detalle_cumplimiento_lead_time: '',
        lead_time_cargos: '',
        causa_cumplimiento_lead_time_cargos: '',
        estado_retorno_cargos: '',
        lead_time_retorno_doc: '',
        cumplimiento_lead_time_retorno: '',
        causa_cumplimiento_lead_time_retorno: '',
        conformidad: '',
        observaciones: '',
        horario_salida: null,
        horario_entrega: '',
        area_gestion: '',
        solicitante: '',
        tipo_paquete: 'documentos',
        retorno_cargos: 0,
        observaciones_emergencia: '',
        max: ''
      },
      codigosMetodoEnvio: [],
      detallesMetodoEnvio: [],
      tiposEnvio: [],
      empresas: [],
      tipoUnidades: [],
      sucursalesRemitente: [],
      sucursalesDestinatario: [],
      detalleUnidad: '',
      showdetalleUnidad: false,
      sucursalDestinatario: {},
      serviciosExtras: [],

      // Variables del formulario
      servicioSeleccionado: '',
      cantidad: 1,
      costoPorHora: 0,
      costoPorDia: 0,
      total: 0,
      // Lista de servicios agregados
      serviciosAgregados: [],
      solicitudesEnvio: [],
      nombrePaquete: '',
      alto: 0,
      largo: 0,
      ancho: 0,
      pesoReal: 0,
      pesoVolumetrico: 0,
      costoPorKg: 0,
      costoPaquete: 0,
      paquetes: [],
      tipo_costo: 'sobre_gestion',

    }
  },
  async mounted() {
    this.isLoading = true;
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      this.form.solicitante = `${user.name} ${user.apellido}`;
      this.validarFechaSalida()
      await this.getCodigoMetodoEnvio()
      await this.getEmpresas()
      await this.getTipoUnidades()
      await this.buscarUnidad()
      await this.getServiciosExtras()
      this.cargarDepartamentos()
      if (this.envioId) {
        await this.getEnvio()
        await this.getDetalleMetodoEnvio()
        await this.getSolicitudesEnvio()
        await this.generarRangosHoras()
      }
      await this.getSucursalesRemitente()
      await this.getSucursalesDestinatario()
      await this.buscarDireccionRemitente()
    }
    catch (error) {
      console.error('Error al cargar los datos del envío:', error);
      this.isLoading = false;
    } finally {
      this.isLoading = false;
    }
  },
  computed: {
    // La ruta del menu usa 'aereo-documentos' y al editar llega 'aereo'.
    esAereo() {
      return ['aereo', 'aereo-documentos'].includes(this.tipoEnvio)
    },
    totalPaquetes() {
      return this.paquetes.length
    },
    totalPesoVolumetrico() {
      return this.paquetes.reduce((total, p) => total + p.pesoVolumetrico, 0)
    },
    totalPesoReal() {
      return this.paquetes.reduce((total, p) => total + p.peso, 0)
    },
    costoTotal() {
      return this.paquetes.reduce((total, p) => total + p.costo, 0)
    },
  },
  watch: {
    form: {
      handler(newForm) {
        if (newForm.destinatario) {
          this.errors.destinatario = false
        }
        if (newForm.sucursal_destinatario_id) {
          this.errors.sucursal_destinatario_id = false
        }
        if (newForm.remitente) {
          this.errors.remitente = false
        }
        if (newForm.sucursal_remitente_id) {
          this.errors.sucursal_remitente_id = false
        }
      },
      deep: true, // Permite observar cambios en propiedades internas de `form`
    },
    '$route.params.tipo_envio'(nuevoValor) {
      this.tipoEnvio = nuevoValor
      this.validarFechaSalida()
      this.changeHoraSalida()
      this.getTipoEnvio()
    },
    paquetes: {
      handler(newVal) {
        this.form.cant_bultos = newVal.length
        this.form.peso_volumen = newVal.reduce(
          (total, p) => total + p.pesoVolumetrico,
          0,
        )
        this.form.peso_bruto = newVal.reduce((total, p) => total + p.peso, 0)
      },
      deep: true,
    },
  },
  methods: {
    validarFechaSalida() {
      if (this.esAereo || this.tipoEnvio == "consolidado") {
        const ahora = new Date();
        let fechaMin = new Date();

        if (ahora.getHours() >= 16) {
          fechaMin.setDate(fechaMin.getDate() + 1);
        }
        const yyyy = fechaMin.getFullYear();
        const mm = String(fechaMin.getMonth() + 1).padStart(2, '0');
        const dd = String(fechaMin.getDate()).padStart(2, '0');

        this.fechaSalidaMinimaAereo = `${yyyy}-${mm}-${dd}`;
      } else {
        this.fechaSalidaMinimaAereo = ""
      }
    },
    changeHoraSalida() {
      if (this.form.horario_salida != "") {
        const [horaStr, minStr] = this.form.horario_salida.split(':');
        let horaMAxima = 24
        let horaMAximaString = ""
        if (this.esAereo) {
          horaMAxima = 16
          horaMAximaString = "4:00 p.m"
        } else if (this.tipoEnvio == "consolidado") {
          horaMAxima = 16
          horaMAximaString = "4:00 p.m"
        }

        if (parseInt(horaStr) > horaMAxima || (parseInt(horaStr) == horaMAxima && parseInt(minStr) >= 1)) {
          this.form.horario_salida = ""
          Swal.fire("Advertencia", "la hora de Salida, no puede ser mayor de las " + horaMAximaString);
          return;
        } else {
          this.getTipoEnvio()
          this.getSolicitudesEnvio()
        }
      }
    },
    async cargarDepartamentos() {
      try {
        this.provincias = []
        const response = await axios.get('/departamentos')
        this.departamentos = response.data
      } catch (error) {
        console.error('Error al cargar departamentos', error)
      }
    },
    async cargarProvincias() {
      try {
        this.distritos = []
        const response = await axios.get(
          '/provinciasByDepartamentos/' + this.direccionEdit.departamento_id,
        )
        this.provincias = response.data
      } catch (error) {
        console.error('Error al cargar provincias', error)
      }
    },
    async cargarDistritos() {
      try {
        const response = await axios.get(
          '/distritosByProvincias/' + this.direccionEdit.provincia_id,
        )
        this.distritos = response.data
      } catch (error) {
        console.error('Error al cargar distritos', error)
      }
    },
    async getEnvio() {
      try {
        const response = await axios.get('envios/' + this.envioId)
        this.form = response.data // Usar response.data
        this.tipoEnvio = response.data.modalidades_envio.toLowerCase()
      } catch (error) {
        console.error('Error cargando detalles de envío:', error)
      }
    },
    generarRangosHoras() {
      let rangos = []
      const tipoEnvio = this.$route.params.tipo_envio
      const incremental = tipoEnvio === 'exclusivo' ? 1 : 1

      const fechaProgramada = this.form.fecha_entrada
      const fechaMaxima = this.form.fecha_entrada_maxima

      if (!fechaProgramada || !fechaMaxima) return []

      if (fechaMaxima === fechaProgramada) {
        // Solo horas sueltas: 3PM a 6PM
        if (tipoEnvio === 'exclusivo') {
          const horaInicio = tipoEnvio === 'exclusivo' ? 8 : 9
          for (let i = horaInicio; i < 18; i += incremental) {
            let inicio = this.formatearHora(i)
            let fin = this.formatearHora(i + incremental)
            if (i + incremental <= 18) { // para evitar pasarse de las 6pm
              rangos.push(`${inicio} - ${fin}`)
            }
          }
        } else {
          for (let hora = 15; hora <= 18; hora++) {
            rangos.push(this.formatearHora(hora))
          }
        }
      } else if (fechaMaxima > fechaProgramada) {
        const horaInicio = tipoEnvio === 'exclusivo' ? 8 : 9
        for (let i = horaInicio; i < 18; i += incremental) {
          let inicio = this.formatearHora(i)
          let fin = this.formatearHora(i + incremental)
          if (i + incremental <= 18) { // para evitar pasarse de las 6pm
            rangos.push(`${inicio} - ${fin}`)
          }
        }
      }

      this.rangosHoras = rangos
      return rangos
    },
    formatearHora(hora) {
      let sufijo = hora < 12 ? 'AM' : 'PM'
      let hora12 = hora <= 12 ? hora : hora - 12
      return `${hora12}:00 ${sufijo}`
    },
    formatCurrency(value) {
      return new Intl.NumberFormat('es-PE', {
        style: 'currency',
        currency: 'PEN',
        minimumFractionDigits: 0,
      }).format(value)
    },
    async getCodigoMetodoEnvio() {
      try {
        const response = await axios.get('cod-metodo-envio')
        this.codigosMetodoEnvio = response.data // Usar response.data
      } catch (error) {
        console.error('Error cargando códigos de método de envío:', error)
      }
    },

    async getDetalleMetodoEnvio() {
      if (this.form.cod_metodo_envio_id) {
        this.errors.cod_metodo_envio_id = false // Se elimina el error cuando se selecciona un valor válido
      }
      try {
        const response = await axios.get(
          'detalle-envio-by-codigo/' +
          this.form.cod_metodo_envio_id +
          '?es_documento=true',
        )
        this.detallesMetodoEnvio = response.data // Usar response.data
      } catch (error) {
        console.error('Error cargando detalles de método de envío:', error)
      }
    },
    buscarDireccionRemitente() {
      if (this.form.sucursal_remitente_id) {
        this.errors.sucursal_remitente_id = false
        this.sucursalRemitente = this.sucursalesRemitente.find(
          (item) => item.id == this.form.sucursal_remitente_id,
        )
      }
      console.log("this.sucursalRemitente ", this.sucursalRemitente)
    },
    async getSolicitudesEnvio() {
      this.buscarPrecio()
      console.log("this.form.horario_salida", this.form.horario_salida)
      console.log("this.form.fecha_salida", this.form.fecha_salida)
      if (this.form.horario_salida == null || this.form.fecha_salida == null) { return; }
      const ahora = new Date();

      function crearFechaLocal(fechaStr) {
        const partes = fechaStr.split('-');
        const anio = parseInt(partes[0], 10);
        const mes = parseInt(partes[1], 10) - 1;
        const dia = parseInt(partes[2], 10);
        return new Date(anio, mes, dia);
      }

      const inicioVentana = new Date();
      inicioVentana.setHours(13, 0, 0, 0);

      const finVentana = new Date(inicioVentana);
      finVentana.setDate(finVentana.getDate() + 1);

      const fechaSalida = crearFechaLocal(this.form?.fecha_salida);

      const inicioDiaActual = new Date();
      inicioDiaActual.setHours(0, 0, 0, 0);

      const esFechaSalidaValida = fechaSalida.getTime() === inicioDiaActual.getTime();

      const enVentana = ahora >= inicioVentana && ahora < finVentana;

      const todas = [
        { id_solicitudes_envio: 2, nombre: "URGENCIA", created_at: "2025-02-21T20:49:37.000000Z" },
        { id_solicitudes_envio: 3, nombre: "EMERGENCIA", created_at: "2025-02-21T20:49:37.000000Z" },
        { id_solicitudes_envio: 1, nombre: "NORMAL", created_at: "2025-02-21T20:49:37.000000Z" }
      ];

      if (enVentana && esFechaSalidaValida) {
        this.isEmergency = true
        this.solicitudesEnvio = todas.filter(s =>
          s.nombre === 'URGENCIA' || s.nombre === 'EMERGENCIA'
        );
      } else {
        this.isEmergency = false
        this.solicitudesEnvio = todas.filter(s =>
          s.nombre === 'NORMAL'
        );
      }
      this.getTipoEnvio()

      // Debug
      console.log("ahora:", ahora);
      console.log("inicioVentana:", inicioVentana);
      console.log("finVentana:", finVentana);
      console.log("fechaSalida:", fechaSalida);
      console.log("inicioDiaActual:", inicioDiaActual);
      console.log("enVentana:", enVentana);
      console.log("esFechaSalidaValida:", esFechaSalidaValida);

      this.form.id_solicitudes_envio = 1;

    },

    async getServiciosExtras() {
      try {
        const response = await axios.get('servicios-extras')
        this.serviciosExtras = response.data // Usar response.data
      } catch (error) {
        console.error('Error cargandoservicios Extras:', error)
      }
    },
    async getTipoEnvio() {
      if (this.form.horario_salida == null || this.form.fecha_salida == null) { return; }
      try {
        const ids = this.calcularIdsTipoEnvio();
        const response = await axios.get('tipos-envio', { params: { ids } });

        this.tiposEnvio = response.data;
        this.form.id_tipo_envio = ids[0];
      } catch (error) {
        console.error('Error cargando tipos de envío:', error);
      }
    },
    calcularIdsTipoEnvio() {
      console.log("this.tipoEnvio", this.tipoEnvio)
      const tipo = this.tipoEnvio;
      const form = this.form;

      if (['exclusivo', 'consolidado'].includes(tipo)) {
        return [5];
      }

      if (this.esAereo) {
        const esHoy = this.esFechaHoyOManana(form.fecha_salida);
        const horaActual = new Date().getHours();
        const salidaTarde = this.salidaEsDespuesDeHora(form.horario_salida, 16);

        if (esHoy && (horaActual >= 13 && salidaTarde)) {
          return [1]; // Prime
        }

        return [3]; // Aéreo normal
      }

      return []; // Tipo desconocido
    },

    esFechaHoyOManana(fechaString) {
      const hoy = new Date();
      hoy.setHours(0, 0, 0, 0);

      const mañana = new Date(hoy);
      mañana.setDate(hoy.getDate() + 1); // Suma un día
      mañana.setHours(0, 0, 0, 0);

      const [year, month, day] = fechaString.split('-');
      const fecha = new Date(+year, +month - 1, +day);
      fecha.setHours(0, 0, 0, 0);

      return (
        fecha.getTime() === hoy.getTime() ||
        fecha.getTime() === mañana.getTime()
      );
    },

    salidaEsDespuesDeHora(horario, horaLimite) {
      if (!horario) return false;

      const [horaStr, minStr] = horario.split(':');
      const hora = parseInt(horaStr);
      const minutos = parseInt(minStr);

      return hora > horaLimite || (hora === horaLimite && minutos > 0);
    },

    async getTipoUnidades() {
      try {
        let ids = [6,7]
        const params = ids.length ? { ids: ids.join(',') } : {} // Convertir array a string si hay IDs
        const response = await axios.get('tipo-unidades', { params })
        this.tipoUnidades = response.data
        this.form.tipo_unidad=6;
        console.log('this.tipoUnidades:', this.tipoUnidades)
      } catch (error) {
        console.error('Error cargando tipoUnidades:', error)
      }
    },
    buscarUnidad() {
      this.detalleUnidad = this.tipoUnidades.find(
        (item) => item.id == this.form.tipo_unidad,
      )
      this.buscarPrecio()
    },
    buscarDireccionDestinatario() {
      this.sucursalDestinatario = this.sucursalesDestinatario.find(
        (item) => item.id == this.form.sucursal_destinatario_id,
      )
      this.buscarPrecio()
    },
    async buscarPrecio() {
      try {
        if (!this.sucursalDestinatario.distrito_id) {
          this.limpiarPrecios()
          return
        }

        let url = ''

        if (this.tipoEnvio === 'exclusivo') {
          if(this.sucursalDestinatario.departamento_nombre!="Lima"){
            this.sucursalDestinatario = {};
            this.form.sucursal_destinatario_id = '';
             Swal.fire({
              icon: 'warning',
              title: 'Sin cobertura',
              text: 'Lo sentimos, no hay cobertura para el destino seleccionado.',
              confirmButtonText: 'Aceptar'
            });
            return;
          }
          url = `precio-exclusivo/${this.form.tipo_unidad}/${this.sucursalDestinatario.distrito_id}/${this.form.cant_conductor}`
        } else if (this.esAereo) {
          url = `precio-consolidado-aereo-documentos/sobre_gestion/${this.sucursalDestinatario.distrito_id}`
        } else {
          url = `precio-consolidado-documentos/${this.tipo_costo}/${this.sucursalDestinatario.distrito_id}`
        }

        const response = await axios.get(url)
        const data = response.data
        this.form.lead_time_esperado = data.lead_time
        const horas = parseInt(this.form.lead_time_esperado);
        const fechaSalida = new Date(this.form.fecha_salida);
        const fechaEntrega = new Date(fechaSalida.getTime() + horas * 60 * 60 * 1000);

        this.form.fecha_entrada = fechaEntrega.toISOString().split('T')[0];

        if (this.tipoEnvio === 'exclusivo') {
          this.form.precio_servicio = data.precio_servicio
        }else{
          this.form.precio_servicio = data.costo
        }
      } catch (error) {
        console.error(`Error al cargar precios (${this.tipoEnvio}):`, error)

        if (error.response && error.response.status === 404) {
          if (this.esAereo) {
            Swal.fire({
              icon: 'warning',
              title: 'Sin cobertura',
              text: 'Lo sentimos, no hay cobertura para el destino seleccionado.',
              confirmButtonText: 'Aceptar'
            });
          } else {
            Swal.fire({
              icon: 'error',
              title: 'Aún sin tarifario definido',
              text: 'Comunicarse con el proveedor.',
            });
          }
        } else {
          if (this.esAereo) {
            Swal.fire({
              icon: 'warning',
              title: 'Sin cobertura',
              text: 'Lo sentimos, no hay cobertura para el destino seleccionado.',
              confirmButtonText: 'Aceptar'
            });
          } else {
            Swal.fire({
              icon: 'error',
              title: 'Aún sin tarifario definido',
              text: 'Comunicarse con el proveedor.',
            });
          }
        }

        this.limpiarPrecios()
      }
    },


    limpiarPrecios() {
      this.form.lead_time_esperado = ''
      this.form.falso_flete_provincia = 0
      this.form.precio_servicio = 0
    },

    openModalDirecciones(empresa_id, data, tipo) {
      // Inicializa todas las propiedades para mantener reactividad
      this.tipoEmpresa = tipo;
      this.sucursalesData = data;
      // Si ya existe direccionEdit, actualiza sus propiedades, no reemplaces el objeto
      if (!this.direccionEdit) this.direccionEdit = {};
      this.direccionEdit.empresa_id = empresa_id;
      this.direccionEdit.nombre = '';
      this.direccionEdit.direccion = '';
      this.direccionEdit.distrito_id = null;
      this.direccionEdit.nombre_contacto = '';
      this.direccionEdit.cargo_contacto = '';
      this.direccionEdit.telefono_contacto = '';
      this.direccionEdit.email_contacto = '';
      this.showModalDirecciones = true;
    },
    resetDireccion() {
      this.direccionEdit = {
        empresa_id: this.direccionEdit.empresa_id, // se conserva: el modal sigue siendo de la misma empresa
        nombre: '',
        direccion: '',
        distrito_id: null,
        nombre_contacto: '',
        cargo_contacto: '',
        telefono_contacto: '',
        email_contacto: '',
      }
    },
    agregarDocumento() {

      this.form.documentos.push({ ...this.formDocumento })
      this.formDocumento = {
        detalle_metodo_envio_id: '',
        guia_remitente: '',
        nro_pedido: '',
        orden_compra: '',
        numero_factura: '',
        otm: '',
        documentos_extras: '',
      }

    },
    getDetalleMetodoEnvioById(detalle_metodo_envio_id) {
      if (this.detallesMetodoEnvio.length > 0) {
        const item = this.detallesMetodoEnvio.find(item => item.id == detalle_metodo_envio_id)
        return item ? item.detalle : ''
      }
      return ''
    },
    eliminarDocumento(index) {
      this.form.documentos.splice(index, 1)
    },
    agregarPaquete() {
      if (
        !this.nombrePaquete ||
        !this.alto ||
        !this.ancho ||
        !this.largo ||
        !this.pesoReal
      ) {
        alert('Completa todos los campos antes de agregar el paquete.')
        return
      }

      this.paquetes.push({
        nombre: this.nombrePaquete,
        alto: this.alto,
        ancho: this.ancho,
        largo: this.largo,
        peso: this.pesoReal,
        pesoVolumetrico: this.pesoVolumetrico,
        costo: this.costoPaquete,
      })

      // Limpiar los campos
      this.nombrePaquete = ''
      this.alto = ''
      this.ancho = ''
      this.largo = ''
      this.pesoReal = ''
      this.pesoVolumetrico = 0
      this.costoPaquete = 0
    },
    eliminarPaquete(index) {
      this.paquetes.splice(index, 1)
    },

    calcularCosto() {
      this.pesoVolumetrico = (this.alto * this.ancho * this.largo) / 5000
      let mayorPeso = Math.max(this.pesoReal, this.pesoVolumetrico)
      this.costoPaquete = parseFloat((mayorPeso * this.costoPorKg).toFixed(2))
    },
    cargarDatosServicio() {
      if (this.servicioSeleccionado) {
        this.costoPorHora = this.servicioSeleccionado.costo_por_hora
        this.costoPorDia = this.servicioSeleccionado.costo_por_dia
        this.calcularTotal()
      }
    },
    // Calcular el total basado en cantidad
    calcularTotal() {
      if (this.servicioSeleccionado) {
        if (this.costoPorHora > 0) {
          this.total = (this.costoPorHora * this.cantidad).toFixed(2)
        } else {
          this.total = (this.costoPorDia * this.cantidad).toFixed(2)
        }
      }
    },
    async getEmpresas() {
      try {
        const response = await axios.get('empresas')
        this.empresas = response.data // Usar response.data
      } catch (error) {
        console.error('Error cargando empresas:', error)
      }
    },
    async getSucursalesRemitente(actualizarDatos) {
      if (this.form.remitente) {
        try {
          const response = await axios.get(
            'empresa-sucursales/' + this.form.remitente,
          )
          this.sucursalesRemitente = response.data // Usar response.data
          if (actualizarDatos) {
            this.sucursalesData = response.data
          }
          console.log('this.sucursales:', this.sucursalesRemitente)
        } catch (error) {
          console.error('Error cargando sucursales:', error)
        }
      }

    },

    async getEmpresaRemitente() {
      try {

        const response = await axios.get(
          'empresa-by-ruc/' + this.form.ruc_remitente,
        )

        const empresa = response.data

        if (empresa && empresa.id) {
          this.form.remitente = empresa.id
          this.getSucursalesRemitente()
        } else {
          this.form.remitente = null
          Swal.fire({
            icon: 'warning',
            title: 'Empresa no encontrada',
            text: 'No se encontró una empresa con ese RUC.',
          })
        }
      } catch (error) {
        console.error('Error buscando empresa:', error)

        if (error.response && error.response.status === 404) {
          Swal.fire({
            icon: 'warning',
            title: error.response.data.error || 'Empresa no encontrada',
            text: error.response.data.message || 'No se encontró una empresa con ese RUC.',
          })
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Error de conexión',
            text: 'Ocurrió un error al consultar la empresa. Intenta nuevamente.',
          })
        }
      }
    },


    async getEmpresaDestinatario() {
      try {


        const response = await axios.get(
          'empresa-by-ruc/' + this.form.ruc_destinatario,
        )

        const empresa = response.data

        if (empresa && empresa.id) {
          // Si es el mismo destinatario, igual se recarga la lista (pueden haber
          // agregado sucursales), pero se conservan precio y contacto ya cargados.
          const esElMismoDestinatario = this.form.destinatario === empresa.id

          this.form.destinatario = empresa.id
          this.getSucursalesDestinatario(false, esElMismoDestinatario)
        } else {
          this.form.destinatario = null
          Swal.fire({
            icon: 'warning',
            title: 'Empresa no encontrada',
            text: 'No se encontró una empresa con ese RUC.',
          })
        }
      } catch (error) {
        console.error('Error cargando empresas:', error)

        if (error.response && error.response.status === 404) {
          Swal.fire({
            icon: 'warning',
            title: error.response.data.error || 'Empresa no encontrada',
            text: error.response.data.message || 'No existe ninguna empresa registrada con ese RUC.',
          })
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Error de conexión',
            text: 'Ocurrió un error al consultar la empresa destinataria.',
          })
        }
      }
    },
    // conservarDatos: recarga la lista de sucursales sin perder el precio
    // calculado ni el contacto (se usa al volver a buscar el mismo RUC).
    async getSucursalesDestinatario(actualizarDatos, conservarDatos = false) {
      if (!conservarDatos) {
        this.sucursalDestinatario = {};
      }
      this.sucursalesData = [];
      if (this.form.destinatario) {
        if (!conservarDatos) {
          this.limpiarPrecios();
        }
        try {
          const response = await axios.get('empresa-sucursales/' + this.form.destinatario);
          this.sucursalesDestinatario = response.data;
          if (actualizarDatos) {
            this.sucursalesData = response.data;
            console.log('this.sucursalesData', this.sucursalesData);
          }
          // Eliminar preselección automática - el usuario debe seleccionar manualmente
          console.log('this.getSucursalesDestinatario:', this.sucursalesDestinatario);
        } catch (error) {
          console.error('Error cargando sucursales:', error);
        }
      }
    },
    editarDireccion(direccion) {
      this.direccionEdit = { ...direccion };
      this.editandoDireccion = true;
      this.editId = direccion.id;
      this.cargarProvincias();
      this.cargarDistritos();
    },
    async eliminarDireccion(id) {
      try {
        await axios.delete(`sucursales/${id}`);
        this.getSucursalesDestinatario();
      } catch (error) {
        console.error('Error al eliminar dirección:', error);
      }
    },
    async guardarDireccion() {
      try {
        if (this.editandoDireccion) {
          await axios.put(`sucursales/${this.editId}`, this.direccionEdit);
        } else {
          await axios.post('sucursales', this.direccionEdit);
        }
        this.resetDireccion();  // Reset form
        if (this.tipoEmpresa == "remitente") {
          await this.getSucursalesRemitente(true);
        } else {
          await this.getSucursalesDestinatario(true);
        }

      } catch (error) {
        console.error('Error al guardar dirección:', error);
      }
    },
    // Agregar el servicio a la tabla
    agregarServicio() {
      if (!this.servicioSeleccionado || this.cantidad <= 0) {
        alert('Seleccione un servicio y una cantidad válida.')
        return
      }

      this.serviciosAgregados.push({
        servicio: this.servicioSeleccionado.servicio,
        cantidad: this.cantidad,
        costoPorHora: this.costoPorHora,
        costoPorDia: this.costoPorDia,
        total: this.total,
      })

      // Reiniciar los campos
      this.servicioSeleccionado = ''
      this.cantidad = 1
      this.costoPorHora = 0
      this.costoPorDia = 0
      this.total = 0
    },
    // Eliminar un servicio de la tabla
    eliminarServicio(index) {
      this.serviciosAgregados.splice(index, 1)
    },
    validateForm() {
      this.errors = {}

      if (!this.form.cod_metodo_envio_id) {
        this.errors.cod_metodo_envio_id = 'Campo obligatorio'
      }
      
      if (!this.form.id_tipo_envio) {
        this.errors.id_tipo_envio = 'Campo obligatorio'
      }
      if (!this.form.id_solicitudes_envio) {
        this.errors.id_solicitudes_envio = 'Campo obligatorio'
      }
      if (!this.form.fecha_salida) {
        this.errors.fecha_salida = 'Campo obligatorio'
      }
      if (!this.form.horario_salida) {
        this.errors.horario_salida = 'Campo obligatorio'
      }
      if (!this.form.fecha_entrada) {
        this.errors.fecha_entrada = 'Campo obligatorio'
      }
      if (!this.form.horario_entrega) {
        this.errors.horario_entrega = 'Campo obligatorio'
      }
      if (!this.form.ruc_remitente) {
        this.errors.ruc_remitente = 'Campo obligatorio'
      }
      if (!this.form.remitente) {
        this.errors.remitente = 'Campo obligatorio'
      }
      if (!this.form.sucursal_remitente_id) {
        this.errors.sucursal_remitente_id = 'Campo obligatorio'
      }
      if (!this.form.ruc_destinatario) {
        this.errors.ruc_destinatario = 'Campo obligatorio'
      }
      if (!this.form.destinatario) {
        this.errors.destinatario = 'Campo obligatorio'
      }
      if (!this.form.sucursal_destinatario_id) {
        this.errors.sucursal_destinatario_id = 'Campo obligatorio'
      }
      return Object.keys(this.errors).length === 0
    },

    async submitForm() {
      if (!this.validateForm()) {
        console.log('Formulario inválido:', this.errors)
        return
      }
      const ahora = new Date()
      const hora = ahora.getHours()

      const confirmacion = await Swal.fire({
        title: '¿Está seguro de enviar el pedido?',
        text: 'Esta acción no se puede deshacer.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, enviar',
        cancelButtonText: 'Cancelar',
      })

      if (!confirmacion.isConfirmed) {
        return
      }
      if (this.esAereo) {
        if (hora >= 16) {
          // Si es después de la 1 PM
          const result = await Swal.fire({
            title: 'Advertencia',
            text:
              'Estás guardando fuera del horario de corte, vas a aplicar a una tarifa prime ¿Deseas continuar?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, guardar',
            cancelButtonText: 'Cancelar',
          })
          if (!result.isConfirmed) return;
        }
      }

      try {
        let response

        // La ruta del menu es 'aereo-documentos', pero al editar llega 'aereo'
        // (viene de modalidades_envio). Ambos deben mapear a AEREO = 4.
        const modalidadPorTipo = {
          exclusivo: 3,
          consolidado: 2,
          aereo: 4,
          'aereo-documentos': 4,
        }

        const modalidad = modalidadPorTipo[this.tipoEnvio]

        if (modalidad) {
          this.form.id_modalidades_envio = modalidad
        } else if (!this.envioId) {
          // Sin esto se guardaba con la modalidad por defecto del formulario,
          // registrando aereos como exclusivos sin avisar a nadie.
          Swal.fire({
            icon: 'error',
            title: 'Tipo de envío no reconocido',
            text: `No se puede determinar la modalidad para "${this.tipoEnvio}". Vuelve a ingresar desde el menú.`,
          })
          return
        }
        if (this.envioId) {
          response = await axios.put(`envios/${this.envioId}`, this.form)

          Swal.fire({
            icon: 'success',
            title: 'Envío Actualizado',
            text: 'Los datos se han actualizado correctamente.',
            confirmButtonText: 'Aceptar'
          }).then(() => {
            router.push('/listado-envios/documentos');
          });
        } else {
          response = await axios.post('envios', this.form)
          this.pedidoResponse = response.data

          Swal.fire({
            icon: 'success',
            title: 'Envío Guardado',
            html: `Los datos se han guardado correctamente.<br><strong>Su número de rastreo es: ${this.pedidoResponse.rastreo}</strong>`,
            confirmButtonText: 'Aceptar'
          }).then(() => {
            router.push('/listado-envios/documentos');
          });

        }
      } catch (error) {
        console.error(error)

        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Hubo un problema al registrar el envío.',
        })
      }
    },
  },
}
</script>

<style scoped>
.form-group {
  margin-bottom: 10px;
  margin-top: 10px;
}

/* ── Cards ── */
.bg-card {
  background-color: #fff !important;
  border: 1px solid #e8eaf6;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(63,81,181,0.07);
}
.bg-card .card-header {
  background: linear-gradient(90deg, #3f51b5 0%, #5c6bc0 100%) !important;
  color: #fff !important;
  font-weight: 700;
  font-size: 0.9rem;
  border-radius: 9px 9px 0 0 !important;
  padding: 11px 18px;
  border-bottom: none;
  display: flex;
  align-items: center;
  gap: 8px;
}

/* ── Labels ── */
label {
  font-size: 0.7rem;
  font-weight: 600;
  color: #546e7a;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  margin-bottom: 3px;
}
label.required::after {
  content: ' *';
  color: #e53935;
}

/* ── Inputs ── */
.form-control, .form-select {
  font-size: 0.85rem;
  border-color: #e0e0e0;
  border-radius: 6px;
}
.form-control:focus, .form-select:focus {
  border-color: #5c6bc0;
  box-shadow: 0 0 0 0.2rem rgba(63,81,181,0.12);
}
.form-control:disabled, .form-control[readonly] {
  background: #f5f6ff;
  color: #546e7a;
}

/* ── Misc ── */
.font-small { font-size: 0.9rem; }
.col-lg-21 { width: 12.5%; }
.hover-pointer { cursor: pointer; }
.no-resize { resize: none; }
.hide { display: none; }
.table-font-small { font-size: 0.75rem; }

thead th, tbody tr { text-align: center; }

/* ── Modal header ── */
.modal-title { color: #fff !important; }
.btn-close { filter: invert(1); }

@media (min-width: 1200px) and (max-width: 1400px) {
  .col-lg-2 { width: 25%; }
}
</style>
